var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "checked",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#495057}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    transform: "translate(4.749 2.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    d: "M136.247 64.549a.754.754 0 0 0-1.066 0l-9.043 9.019-3.263-3.543a.754.754 0 0 0-1.109 1.021l3.794 4.12a.753.753 0 0 0 .538.243h.016a.755.755 0 0 0 .532-.22l9.6-9.573a.754.754 0 0 0 .001-1.067z",
    className: "cls-1",
    transform: "translate(-121.568 -64.327)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    d: "M19.246 9.246a.754.754 0 0 0-.754.754A8.492 8.492 0 1 1 10 1.508.754.754 0 1 0 10 0a10 10 0 1 0 10 10 .754.754 0 0 0-.754-.754z",
    className: "cls-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.1d3058328ad523528cb2f907c088ad3f.svg";
export { ForwardRef as ReactComponent };